import { useEffect, useState } from "react";
import { DateText } from "./styles";

export function Timer() {
  const [date, setDate] = useState(new Date());

  function formatDate(date){
    const temp = date.toLocaleDateString("pt-BR",{
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
    return temp.replace(',', ' -')
  }

  useEffect(() => {
		const timer = setInterval(() => {
			setDate(new Date())
		}, 1000)

		return () => {
			clearInterval(timer)
		}
	}, [])

  return (
    <DateText>{formatDate(date)}</DateText>
  );
}